import { MAINTENANCE_APP_CODE, MAINTENANCE_MESSAGE_STORAGE_KEY } from "../constants/maintenance.constants";
import { MAINTENANCE as MAINTENANCE_PATH } from "@shared/constants/route.constants";

export function isOnMaintenancePage(): boolean {
  return window.location.pathname.replace(/\/+$/, "").endsWith(`/${MAINTENANCE_PATH}`);
}

export function redirectToMaintenancePage(message?: string | null): void {
  storeMaintenanceMessage(message);
  if (!isOnMaintenancePage()) {
    window.location.replace(new URL(MAINTENANCE_PATH, document.baseURI).href);
  }
}

export function getMaintenanceMessage(): string | null {
  try {
    return sessionStorage.getItem(MAINTENANCE_MESSAGE_STORAGE_KEY);
  } catch {
    return null;
  }
}

function storeMaintenanceMessage(message?: string | null): void {
  try {
    if (message) {
      sessionStorage.setItem(MAINTENANCE_MESSAGE_STORAGE_KEY, message);
    } else {
      sessionStorage.removeItem(MAINTENANCE_MESSAGE_STORAGE_KEY);
    }
  } catch {
    // Storage unavailable (private mode...): the default maintenance text is displayed
  }
}
